/**
 * Created by comoon on 11/12/15.
 */

var Constants = {

    /**
     * ADD Default event change
     */
    CHANGE: "CHANGE"
};

module.exports = {
    add_change(callback, context) {

        this.on(Constants.CHANGE, callback, context);
    },

    remove_change(callback){

        this.off(Constants.CHANGE, callback);
    },

    emit_change(){

        this.emit(Constants.CHANGE);
    },

    add_event(eventName, callback, context){

        this.on(eventName, callback, context);
    },

    remove_event(eventName, callback){

        this.off(eventName, callback);
    },

    emit_event(eventName, data){

        this.emit(eventName, data);
    },
    Constants
};


/** WEBPACK FOOTER **
 ** ./script/store/StoreMixin.js
 **/